import { useState } from 'react';
import { Title, Stack, SimpleGrid, Group, Select } from '@mantine/core';
import { PodStatusTable } from './PodStatusTable';
import { AlertsPanel } from './AlertsPanel';
import { ClusterMetricsPanel } from './ClusterMetricsPanel';
import { BackupsPanel } from './BackupsPanel';
import { KeycloakPanel } from './KeycloakPanel';
import { MatomoPanel } from './MatomoPanel';
import { TopConsumersPanel } from './TopConsumersPanel';
import { ConversionsPanel } from './ConversionsPanel';
import { RefreshContext } from './RefreshContext';

const INTERVAL_OPTIONS = [
  { value: '30000', label: '30 Sekunden' },
  { value: '60000', label: '1 Minute' },
  { value: '300000', label: '5 Minuten' },
  { value: '900000', label: '15 Minuten' },
  { value: '1800000', label: '30 Minuten' },
  { value: '3600000', label: '1 Stunde' },
];

export function CockpitPage() {
  const [interval, setInterval] = useState('30000');

  return (
    <RefreshContext.Provider value={Number(interval)}>
      <Stack gap="lg">
        <Group justify="space-between">
          <Title order={2}>Cockpit</Title>
          <Select
            size="xs"
            w={160}
            data={INTERVAL_OPTIONS}
            value={interval}
            onChange={(v) => v && setInterval(v)}
            allowDeselect={false}
          />
        </Group>
        <ClusterMetricsPanel />
        <SimpleGrid cols={{ base: 1, lg: 2 }}>
          <MatomoPanel />
          <ConversionsPanel />
        </SimpleGrid>
        <SimpleGrid cols={{ base: 1, md: 2, lg: 3 }}>
          <KeycloakPanel />
          <AlertsPanel />
          <BackupsPanel />
        </SimpleGrid>
        <TopConsumersPanel />
        <PodStatusTable />
      </Stack>
    </RefreshContext.Provider>
  );
}
